import React from "react";
import Auxiliary from "../HOC/Auxiliary/Auxiliary";
import {connect } from "react-redux";
import "./Notification.css";
// import {TiTickOutline} from "react-icons/ti";
// import {RiErrorWarningLine} from "react-icons/ri";

const Notification =(props)=>{
    let {open, msg,mode}  = props.notificationStatus;
    if(open){
        setTimeout(()=>{
                props.closeNotification({open: false, msg:"", mode:"success"});
        },3000);
    }
       
    return(
        <Auxiliary>
            <div className={`alert alert-${mode} py-1 px-4 notification__style d-flex align-items-center`}
            style={{
                display: open ? "flex" : "none",
                opacity: open ? "1" : "0"
            }}
            >
                <p className="mr-2">{msg}</p>
                {/* { mode === "success" ? <TiTickOutline className={`text-${mode}`} /> : mode === "danger" ? "" :  mode === "warning" ? <RiErrorWarningLine className={`text-${mode}`}/> : <TiTickOutline className={`text-${mode}`}/> } */}
            </div>
        </Auxiliary>
    )
}
const mapStateToProps = state =>{
    return{
        notificationStatus: state.triggerNotification
    }
}

const mapDispatchToProps = dispatch=>{
    return{
        closeNotification: (payload) => dispatch({type: "NOTIFICATION", payload: payload})
    }
}
export default connect(mapStateToProps, mapDispatchToProps) (Notification);